export default "__VITE_ASSET__acc699bc__"